import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Copyright from "../../internals/components/Copyright";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "../../internals/data/customersData";
import { getAgentCustomers } from "../../actions/agent";
import {useNavigate} from 'react-router';

const CustomerList = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	const [rows, setRows] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		getAgentCustomers(token, (res) => {
			if (!res.error) {
				setRows(res.data);
			}else{
                if(res.message.toString().includes("Token Expired")){
                    navigate("/logout");
                }
            }
		});
	}, []);

	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Customers
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ textAlign: "center" }}>
					{rows ? (
						<DataGrid
							checkboxSelection={false}
							rows={rows}
							columns={columns}
							getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd")}
							initialState={{
								pagination: { paginationModel: { pageSize: 20 } },
							}}
							pageSizeOptions={[10, 20, 50]}
							disableColumnResize
							showToolbar
							density="compact"
							slotProps={{
								filterPanel: {
									filterFormProps: {
										logicOperatorInputProps: {
											variant: "outlined",
											size: "small",
										},
										columnInputProps: {
											variant: "outlined",
											size: "small",
											sx: { mt: "auto" },
										},
										operatorInputProps: {
											variant: "outlined",
											size: "small",
											sx: { mt: "auto" },
										},
										valueInputProps: {
											InputComponentProps: {
												variant: "outlined",
												size: "small",
											},
										},
									},
								},
							}}
						/>
					) : (
						<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
							<Box>
								<CircularProgress color="primary" size={80} thickness={5} />
							</Box>
						</Grid>
					)}
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default CustomerList;
